import { i18nCategoryFilter } from "app/filters/ngFilters";
import type { ReactNode } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

interface ICategoryFilterCellProps<V> extends Pick<ITableCellProps<V>, "onItemClick" | "value"> {
    filter?: (value: V) => ReactNode;
}

export const CategoryFilterCell = <V,>({
    value,
    onItemClick,
    filter = i18nCategoryFilter(),
}: ICategoryFilterCellProps<V>) => {
    return (
        <a
            onClick={() => onItemClick("category", value)}
            className="category-filter-cell"
        >
            {filter(value)}
        </a>
    );
};
CategoryFilterCell.displayName = "CategoryFilterCell";
